import React from 'react';
import { 
  Grid, 
  Column, 
  Tile
} from '@carbon/react';
import PageContainer from '../components/PageContainer';
import AdminShiftCalendar from '../components/AdminShiftCalendar';

const ShiftManagement = () => {
  return (
    <PageContainer title="Upravljanje smenama" subtitle="Organizacija i praćenje radnih smena">
      <Grid fullWidth condensed style={{ height: '100%' }}>
        <Column lg={16} md={8} sm={4} style={{ height: '100%', display: 'flex', flexDirection: 'column', paddingLeft: 0 }}>
          <Tile style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <AdminShiftCalendar />
          </Tile>
        </Column>
      </Grid>
    </PageContainer>
  );
};

export default ShiftManagement;
